module.exports = __webpack_public_path__ + "static/media/icon-checkout.4ef5656a.svg";